import { Provider } from '@angular/core';
import { METER_COLUMNS, MeterColumn, MeterColumnConfig } from '@contracts';
import { DEFAULT_ENERGY_METER_COLUMNS } from '@feature/meter';

const METER_COLUMN: MeterColumn[] = [
  ...DEFAULT_ENERGY_METER_COLUMNS,

  {
    key: 'i_avg',
    order: 230,
    label: 'view_value.i_avg',
    field: 'i_avg',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'kvar_phase_1',
    order: 240,
    label: 'view_value.kvar_phase_1',
    field: 'kvar_phase_1',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'kvar_phase_2',
    order: 250,
    label: 'view_value.kvar_phase_2',
    field: 'kvar_phase_2',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'kvar_phase_3',
    order: 260,
    label: 'view_value.kvar_phase_3',
    field: 'kvar_phase_3',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },

  {
    key: 'thd_v1',
    order: 230,
    label: 'view_value.thd_v1',
    field: 'thd_v1',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'thd_v2',
    order: 240,
    label: 'view_value.thd_v2',
    field: 'thd_v2',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'thd_v3',
    order: 250,
    label: 'view_value.thd_v3',
    field: 'thd_v3',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'v_12',
    order: 260,
    label: 'view_value.v_12',
    field: 'v_12',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'v_23',
    order: 270,
    label: 'view_value.v_23',
    field: 'v_23',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'v_31',
    order: 280,
    label: 'view_value.v_31',
    field: 'v_31',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'thd_i1',
    order: 290,
    label: 'view_value.thd_i1',
    field: 'thd_i1',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'thd_i2',
    order: 300,
    label: 'view_value.thd_i2',
    field: 'thd_i2',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'thd_i3',
    order: 310,
    label: 'view_value.thd_i3',
    field: 'thd_i3',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'pf',
    order: 320,
    label: 'view_value.pf',
    field: 'pf',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'kva',
    order: 330,
    label: 'view_value.kva',
    field: 'kva',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },

  {
    key: 'i_n',
    order: 230,
    label: 'view_value.i_n',
    field: 'i_n',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'kw_phase_1',
    order: 240,
    label: 'view_value.kw_phase_1',
    field: 'kw_phase_1',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'kw_phase_2',
    order: 250,
    label: 'view_value.kw_phase_2',
    field: 'kw_phase_2',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'kw_phase_3',
    order: 260,
    label: 'view_value.kw_phase_3',
    field: 'kw_phase_3',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'kvar',
    order: 270,
    label: 'view_value.kvar',
    field: 'kvar',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'freq',
    order: 280,
    label: 'view_value.freq',
    field: 'freq',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
];

export const APP_METER_PROVIDER_BILLENIUM: Provider = {
  provide: METER_COLUMNS,
  useValue: {
    energy: {
      ems: [...METER_COLUMN],
      rms: [...METER_COLUMN],
    },
  } satisfies MeterColumnConfig,
};
